import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { compareDateStrings } from '@epicuro-next/utilities';

import { DocumentType, IAccountDocument } from '../models';
import { DOCUMENTS_API_TOKEN } from '../token';

@Injectable()
export class DocumentsApiService {
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENTS_API_TOKEN) private url: string,
  ) {
    if (!url) throw Error('DOCUMENTS_API_TOKEN not provided');
  }

  public static SortNewestFirst(documents: IAccountDocument[]) {
    return documents
      .slice()
      .sort((a, b) =>
        compareDateStrings(a.publishedDateTime, b.publishedDateTime),
      );
  }

  public getAccountDocuments(accountId: string, siteId?: string) {
    let url = `${this.url}/account/${accountId}`;
    if (siteId) url = `${url}/${siteId}`;
    return this.http.get<ReadonlyArray<IAccountDocument>>(url);
  }

  public getDocumentFile(
    documentId: number,
    documentVersionId: number,
    languageCode: string,
  ) {
    return this.http.get<string>(
      `${this.url}/${documentId}/version/${documentVersionId}/file/${languageCode}`,
    );
  }

  public postAcceptDocument(
    documentId: number,
    documentVersionId: number,
    accountId: string | null,
  ) {
    let url = `${this.url}/${documentId}/version/${documentVersionId}/accept`;
    if (accountId) {
      url += `?accountId=${accountId}`;
    }
    return this.http.post<void>(url, {});
  }

  public getBasketDocuments(basketId: string) {
    return this.http.get<ReadonlyArray<IAccountDocument>>(
      `${this.url}/basket/${basketId}`,
    );
  }

  public getDocumentsByTypeAndAccountId(
    type: DocumentType,
    accountId: string | null,
  ) {
    return this.http.get<ReadonlyArray<IAccountDocument>>(
      `${this.url}/type/${type}/account/${accountId}`,
    );
  }
}
